import { HintIcon, Space, Text } from '@/components';
import type { SelectProps } from 'antd';
import type { ReactNode } from 'react';
import { Select } from './Select';

type Props<T> = {
  label: string;
  hint?: ReactNode;
  fullWidth?: boolean;
  vertical?: boolean;
  textWeight?: Parameters<typeof Text>[0]['weight'];
  isNoWrapLabel?: boolean;
} & SelectProps<T>;
export const LabeledSelect = <T,>({
  label,
  hint,
  fullWidth,
  vertical,
  textWeight,
  loading,
  isNoWrapLabel,
  ...selectProps
}: Props<T>) => {
  const styles = fullWidth && { style: { width: '100%' } };
  return (
    <Space
      direction={vertical ? 'vertical' : undefined}
      size="small"
      {...styles}
    >
      <Space>
        <Text
          style={isNoWrapLabel ? { whiteSpace: 'nowrap' } : undefined}
          text={label}
          color="secondary"
          weight={textWeight}
        />
        {hint && <HintIcon hint={hint} />}
      </Space>
      <Select
        {...selectProps}
        {...(loading && {
          value: null,
          tagRender: () => <></>,
        })}
        {...styles}
      />
    </Space>
  );
};
